import MainPresetsIcon from '@material-ui/icons/GroupWork'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import BuildIcon from '@material-ui/icons/Build'

export default [
    {
      "path": "/slicer",
      "label": "Product Categories & Brands",
      "icon": AccountBalanceIcon
    },
    {
      "path": "/preset",
      "label": "Ad Sets and Norms",
      "icon": MainPresetsIcon
    },
    {
      "path": "/builder",
      "label": "Builder",
      "icon": BuildIcon
    },
  ]


// WEBPACK FOOTER //
// ./src/app/configuration/CapitalOne/config/sidebar.js